import {
	Action,
	AnyAction,
	ThunkAction,
	combineReducers,
	configureStore,
} from '@reduxjs/toolkit';

import carPaintSlice from './slices/carPaintSlice';
import colorPickerSlice from './slices/colorPickerSlice';
import tuningSlice from './slices/tuningSlice';
import tuningStudioSlice from './slices/tuningStudioSlice';

const reducers = {
	tuning: tuningSlice,
	tuningStudio: tuningStudioSlice,
	carPaint: carPaintSlice,
	colorPicker: colorPickerSlice,
};

const rootReducer = combineReducers(reducers);

const combinedRootReducer = (
	state: ReturnType<typeof rootReducer> | undefined,
	action: AnyAction,
) => {
	if (action.type === 'resetStore') {
		return rootReducer(undefined, action);
	}
	return rootReducer(state, action);
};

export const store = configureStore({
	reducer: combinedRootReducer,
	devTools: import.meta.env.DEV,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;
